<template>
  <modal
    v-if="showModal"
    classes="text-left"
    @closeModal="closeModal"
  >
    <template
      #modal-title
    >
      <h2 class="bold">
        Bancos Afiliados
      </h2>
    </template>
    <div class="flex text-sm">
      <ul class="flex-1">
        <li>Capital Bank</li>
        <li>Banco Nacional de Panamá</li>
        <li>BAC</li>
        <li>Banistmo</li>
        <li>Caja de Ahorros</li>
        <li>Credicorp Bank</li>
        <li>Coopeduc</li>
      </ul>
      <ul class="flex-1">
        <li>Coopeve</li>
        <li>St. Georges Bank</li>
        <li>Towerbank</li>
        <li>Lafise</li>
        <li>Multibank</li>
        <li>Banco Aliado</li>
        <li>Banco General</li>
      </ul>
    </div>
    <button
      class="mt-3 button"
      @click="callClaveService"
    >
      Continuar
    </button>
    <button
      class="mt-3 button"
      @click="closeModal"
    >
      {{ $t('text.goBack') }}
    </button>
  </modal>
</template>

<script>
import { Modal } from '@/components/ui';

export default {
  name: 'ClaveModal',
  components: { Modal },
  props: {
    paymentObject: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    callClaveService() {
      global.api.mpcPostPaymentClave(this.paymentObject).then((res) => {
        window.location.href = res.data;
      }).catch((err) => {
        this.isLoading = false;
        if (err.code === 'ECONNABORTED') {
          this.$router.push({ name: 'Error', query: { error: 'GENERIC_ERROR' } });
        } else {
          this.$router.push({ name: 'Error', query: { error: 'GENERIC_ERROR' } });
        }
      });
    },
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>
